import { toArray, ElementIntersectionObserver, setAttribute } from '@nrk/dh-basis-common'

const CHILD_SELECTOR = 'dh-bs-levende-stillbilde'
const STATE_ATTR = 'data-state'
const VIEWPORT_POSITION_ATTR = 'viewport-position'
const VIEWPORT_POSITION_DATA_ATTR = 'data-viewport-position'

/*
 * Copies down the 'data-state' attribute to child.
 * Detects and sets 'data-viewport-position' on child.
 * */
export default class Wrapper extends HTMLElement {
  static get observedAttributes() {
    return [STATE_ATTR, VIEWPORT_POSITION_ATTR]
  }

  connectedCallback() {
    this._createIntersectionObserver()
  }

  disconnectedCallback() {
    this._disconnectIntersectionObserver()
  }

  attributeChangedCallback(name) {
    if (name === STATE_ATTR || name === VIEWPORT_POSITION_ATTR) {
      this._updateChildElements()
    }
  }

  _createIntersectionObserver() {
    this.containerObserver = new ElementIntersectionObserver([this], this._handleContainerChange, {
      threshold: [0, 0.1, 0.5, 0.9, 1],
    })
  }

  _disconnectIntersectionObserver() {
    if (this.containerObserver) {
      this.containerObserver.disconnect()
    }
  }

  _handleContainerChange = ([containerIntersection]) => {
    if (containerIntersection.isIntersecting) {
      if (this.viewportPosition !== 'IN-VIEWPORT') {
        this.viewportPosition = 'IN-VIEWPORT'
      }
    } else {
      if (this.viewportPosition) {
        this.viewportPosition = undefined
      }
    }
  }

  _updateChildElements() {
    const state = this.state
    const viewportPosition = this.viewportPosition
    const children = toArray(this.querySelectorAll(CHILD_SELECTOR))
    children.forEach((child) => {
      setAttribute(child, STATE_ATTR, state)
      setAttribute(child, VIEWPORT_POSITION_DATA_ATTR, viewportPosition)
    })
  }

  get viewportPosition() {
    return this.getAttribute(VIEWPORT_POSITION_ATTR)
  }

  set viewportPosition(value) {
    setAttribute(this, VIEWPORT_POSITION_ATTR, value)
  }

  get state() {
    return this.getAttribute(STATE_ATTR)
  }

  set state(value) {
    setAttribute(this, STATE_ATTR, value)
  }
}
